import React, {createContext, useReducer} from 'react'
import {LineHaulDetailReducer} from "../reducers/LineHaulDetailReducer";

export const LineHaulDetailContext = createContext();

const LineHaulDetailContextProvider = (props) => {
    const state = {
        details: []
    }
    const [viewModel, dispatch ] = useReducer(LineHaulDetailReducer, state)
    return (
        <LineHaulDetailContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </LineHaulDetailContext.Provider>
    )
}

export default LineHaulDetailContextProvider


// WEBPACK FOOTER //
// ./src/components/linehaul/context/LineHaulDetailContext.js